<template>
  <div class="terms-wrap ptb-100">
    <div class="container">
      <div class="single-para">
        <h3>Website Terms and Conditions</h3>
        <p>
          Welcome to Guac & Grill. These terms and conditions outline the rules and regulations for the use of our website, located at guacngrill.com. By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use Guac & Grill's website if you do not accept all of the terms and conditions stated on this page.
        </p>
      </div>
      <div class="single-para">
        <h3>Reservations and Bookings</h3>
        <p>
          All table reservations made through our website are subject to availability and confirmation. We reserve the right to cancel or modify reservations due to unforeseen circumstances. In the event of a cancellation by the restaurant, we will notify you as soon as possible and offer alternative dates or a full refund if applicable.
        </p>
        <ol>
          <li>
            Reservations must be made at least 2 hours in advance
          </li>
          <li>
            Cancellations should be made at least 4 hours before the reservation time
          </li>
          <li>
            Late arrivals (more than 15 minutes) may result in cancellation of the reservation
          </li>
          <li>
            Special dietary requirements must be communicated at the time of booking
          </li>
        </ol>
      </div>
      <div class="single-para">
        <h3>Online Ordering and Delivery</h3>
        <p>
          When placing orders through our website, you agree to provide accurate and complete information. All prices displayed on our website are in local currency and are subject to applicable taxes and delivery charges. Delivery times are estimates and may vary based on location, weather conditions, and order volume.
        </p>
        <p>
          We are not responsible for any allergic reactions or dietary issues arising from consumption of our food. Please inform us of any known allergies when placing your order.
        </p>
      </div>
      <div class="single-para">
        <h3>Payment Terms</h3>
        <p>
          All payments processed through our website are secure and encrypted. We accept major credit cards, debit cards, and other payment methods as specified on our website. By providing payment information, you represent that you are authorized to use the payment method.
        </p>
        <p>
          In the event of a billing error or disputed charge, please contact us within 7 days of the transaction. We will investigate and resolve legitimate disputes promptly.
        </p>
      </div>
      <div class="single-para">
        <h3>Intellectual Property Rights</h3>
        <p>
          Unless otherwise stated, Guac & Grill and/or its licensors own the intellectual property rights for all material on Guac & Grill. All intellectual property rights are reserved. You may not reproduce, distribute, or create derivative works from our content without prior written consent.
        </p>
      </div>
      <div class="single-para">
        <h3>Limitation of Liability</h3>
        <p>
          Guac & Grill shall not be liable for any indirect, incidental, special, or consequential damages resulting from your use of our website or services. Our maximum liability shall not exceed the amount paid for the specific service or product in question.
        </p>
      </div>
      <div class="single-para">
        <h3>Changes to Terms</h3>
        <p>
          Guac & Grill reserves the right to amend these terms and conditions at any time. Any changes will be posted on this page, and your continued use of the website constitutes acceptance of these changes.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TermsConditions",
});
</script>